module.exports = __webpack_public_path__ + "img/logo_login_inferiore.856ff545.png";